import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import {
  apiActions as commonApiActions,
  apiResourceActionCreator,
  endpointQuery
} from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import getBusinessEmailJobStatusesConfig from './getBusinessEmailJobStatuses';

const actions = createActions({
  TASK: {
    GET_BUSINESS_TASKS: (businessId, query) => ({ businessId, query }),
    API: {
      GET_BUSINESS_TASKS: apiResourceActionCreator('businessTasks')
    }
  }
});

export const apiAction = (authToken, businessId, query) =>
  commonApiActions.authenticated.get(
    `${API_ENDPOINT}/business-tasks/${businessId}${endpointQuery(query)}`,
    authToken,
    actions.task.api.getBusinessTasks
  );

/**
 * Saga worker that fetches tasks for a given business and triggers
 * an immediate fetch of associated background email job statuses.
 */
function* getBusinessTasks(action) {
  const authToken = yield select(authTokenSelector);
  const { businessId, query } = action.payload;

  yield put(apiAction(authToken, businessId, query));

  yield put(
    getBusinessEmailJobStatusesConfig.action.task.getBusinessEmailJobStatuses(
      businessId
    )
  );
}

/**
 * Redux configuration mapping actions, sagas, and slice reducers
 * for retrieving business-scoped tasks.
 */
const configuration = {
  name: 'getBusinessTasks',
  action: actions,
  sagas: getBusinessTasks,
  reducers: {
    request: (state) => ({ ...state, isFetchingBusinessTasks: true }),
    success: (state, action) => {
      const payloadData = action.payload.businessTasks;
      const hasTasks = payloadData && payloadData.tasks;
      return {
        ...state,
        businessTasks: hasTasks ? payloadData.tasks : payloadData,
        skippedBusinessTaskUserReassessment: Boolean(
          payloadData && payloadData.skippedTaskUserReassessment
        ),
        isFetchingBusinessTasks: false
      };
    },
    failed: (state) => ({ ...state, isFetchingBusinessTasks: false })
  }
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/getBusinessTasks.js